import { CUSTOM_ELEMENTS_SCHEMA,NgModule } from '@angular/core';
import { SidebarNavComponent } from './sidebar-nav.component';
import {
  ConfigurationModule,
  SidebarNavigationModule,
  CommonCoreModule
} from '@ciam/library';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import {
  BoxOpenIcon,
  BrandCourierSIcon,
  BrandCustomsAgentSIcon,
  BrandHomeSIcon,
  BrandKeySIcon,
  BrandSelfServiceShipSIcon,
  BrandUserGroupsSIcon,
  IconModule,
  IconRegistry,
  NavigationalKebabIcon,
  UtilityCircleUserIcon
} from '@ciam/library/src/components/icon';

@NgModule({
  declarations: [ SidebarNavComponent ],
  imports: [
    CommonModule,
    SidebarNavigationModule,
    TranslateModule,
    ConfigurationModule.withSource(
      { url: './assets/configs/config.json', failOnError: true },
      { url: './assets/configs/level.json', failOnError: true }
    ),
    SharedModule,
    IconModule,
    CommonCoreModule
  ],
  exports: [
    SidebarNavComponent
  ],
schemas: [
  CUSTOM_ELEMENTS_SCHEMA
],
})
export class SidebarNavModule {
  constructor(iconRegistry: IconRegistry) {
    iconRegistry.register(
      BoxOpenIcon,
      BrandCourierSIcon,
      BrandCustomsAgentSIcon,
      BrandHomeSIcon,
      BrandKeySIcon,
      BrandSelfServiceShipSIcon,
      BrandUserGroupsSIcon,
      NavigationalKebabIcon,
      UtilityCircleUserIcon
    );
  }
}
